import { Component, computed, signal } from '@angular/core';
import {
    Button,
    Card,
    Input,
    Tabs,
    ThumbnailItemComponent,
    ThumbnailPreview,
} from '@ntv360/component-pantry';
import { TableComponent } from '@shared';
import { SVG_ICONS } from '@shared/constants';

import { DealerInfoComponent } from './tabs/dealer-info/dealer-info.component';
import { HostLocationComponent } from './tabs/host-location/host-location.component';
import { PlaylistComponent } from './tabs/playlist/playlist.component';

import { ADVERTISER_DATA, GALLERY_ITEMS, TABLE_COLUMNS, TAGS } from '../../constants';

@Component({
    selector: 'app-single-advertiser',
    imports: [
        Button,
        Card,
        Input,
        ThumbnailItemComponent,
        TableComponent,
        ThumbnailPreview,
        Tabs,
        DealerInfoComponent,
        HostLocationComponent,
        PlaylistComponent,
    ],
    templateUrl: './single-advertiser.component.html',
    styleUrl: './single-advertiser.component.scss',
})
export class SingleAdvertiserComponent {
    /**
     * Reference to navbar icon constants.
     */
    public icons = SVG_ICONS;

    /**
     * Path to the SVG sprite file.
     */
    public spritePath = 'assets/icons/icons-sprite.svg';

    /**
     * The advertiser data to be displayed.
     */
    public advertiserData = ADVERTISER_DATA;

    /**
     * The tags to be displayed.
     */
    public tags = TAGS;

    /**
     * The gallery items to be displayed.
     */
    public galleryItems = GALLERY_ITEMS;

    /**
     * The current view type of the gallery.
     */
    public currentView = signal<'grid' | 'list'>('grid');

    /**
     * The selected item for the preview.
     */
    public selectedItem = signal<any>(GALLERY_ITEMS[0]);

    /**
     * Table columns for the list view.
     */
    public tableColumns = TABLE_COLUMNS;

    /**
     * Tabs configuration.
     */
    public tabs = [{ label: 'Dealer Info' }, { label: 'Host Location' }, { label: 'Playlist' }];

    /**
     * Active tab index.
     */
    public activeTab = signal(0);

    public itemDetails = computed(() => [
        { label: 'Uploaded By:', value: this.selectedItem()?.uploadedBy || 'Joemar Admin' },
        { label: 'Upload Date:', value: this.selectedItem()?.dateCreated },
        { label: 'Media Type:', value: this.selectedItem()?.type },
        { label: 'Size:', value: this.selectedItem()?.size },
        { label: 'Duration:', value: this.selectedItem()?.duration || 'N/A' },
    ]);

    /**
     * Set the current view type.
     * @param view - The view type to set.
     */
    public setView(view: 'grid' | 'list'): void {
        this.currentView.set(view);
    }

    /**
     * Handle item click event.
     * @param item - The clicked item data.
     */
    public onItemClicked(item: any): void {
        this.selectedItem.set(item);
    }

    /**
     * Handle table cell click event.
     * @param event - The cell click event data.
     */
    public onCellClicked(event: { field: string; value: any; row: any }): void {
        this.selectedItem.set(event.row);
    }

    /**
     * Handles tab change events.
     * @param index - The index of the selected tab.
     */
    public onTabChange(index: number): void {
        this.activeTab.set(index);
    }
}
